import { ElementRef, OnDestroy, AfterViewInit, NgZone, Directive, Optional, Output, EventEmitter  } from '@angular/core';
import { NgControl } from "@angular/forms";
import * as moment from 'moment';

declare var $;

@Directive({
  selector: '[date-dropper]'
})
export class DateDropperDirective implements AfterViewInit, OnDestroy {
  @Output() onDatePicked = new EventEmitter<boolean>();

	constructor(
    private ngZone: NgZone,
    private el: ElementRef,
    @Optional() private control? : NgControl) { }

  ngAfterViewInit(): void {
    if(this.control && this.control.control && this.control.control.value) {
      let format = "";
      let value =this.control.control.value;

      // If value is in YYYY-MM-DD format then change format to this
      if(/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/.test(value)) {
        format = "YYYY-MM-DD";
      }

      // If value is in DD-MM-YYYY format then change format to this
      if(/((0[1-9]|[12]\d|3[01])-(0[1-9]|1[0-2])-[12]\d{3})/.test(value)) {
        format = "DD-MM-YYYY";
      }

      // If value is in DD/MM/YYYY format then change format to this
      if(/((0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/[12]\d{3})/.test(value)) {
        format = "DD/MM/YYYY";
      }

      let momentDate = null;
      if(format) {
        momentDate = moment(this.control.control.value, format);
      } else {
        momentDate = moment(this.control.control.value);
      }

      $(this.el.nativeElement).attr('data-dd-default-date', momentDate.format('MM-DD-YYYY'));
      $(this.el.nativeElement).attr('data-dd-max-year', moment().add(10, 'years').format('YYYY'));
    }

    let additionalOptions = {};
    let self = this;
    if($(this.el.nativeElement).attr('data-dd-roundtrip')) {
      additionalOptions = {
        onRoundTripChange: () => {
          this.ngZone.run( () => {
            this.onDatePicked && this.onDatePicked.emit();
          });
        }
      }
    }

    $(this.el.nativeElement).dateDropper({
      autofill:false,
      // lang: 'ar',
      theme:'teamup',
      ...additionalOptions
    });

    const observer = new MutationObserver((mutations) => {
      for(const mutation of mutations) {
        // @ts-ignore
          for(const addNode of mutation.addedNodes) {
              if(addNode.classList.contains('datedropper')) {
                  setTimeout(() => {
                      const {top } = addNode.getBoundingClientRect();

                      addNode.style.maxHeight = window.innerHeight - top + 'px'
                      addNode.style.overflow = "scroll"
                  }, 100)
              }
            }
        }
    })

    observer.observe(document.body, {
      childList: true,
    })

    this.attachAngularChange();
  }

  attachAngularChange(): void {
    $(this.el.nativeElement).one('change', () => {
      const customEvent = document.createEvent('Event');
      customEvent.initEvent('input', true, true);
      Object.defineProperty(customEvent, 'target', {value: this.el.nativeElement, enumerable: true});
      this.el.nativeElement.dispatchEvent(customEvent);

      this.attachAngularChange();
    });
  }

  ngOnDestroy() {
    $(this.el.nativeElement).dateDropper('destroy');
  }
}
